export const matrices = [
  {
    id: "matrix-1",
    start: [0.37, 0, 0, 0.37, 118.73, 17.03],
    end: [0.4, 0, 0, 0.4, 141.26, 22.34],
  },
  {
    id: "matrix-2",
    start: [0.4, 0, 0, 0.4, 141.26, 22.34],
    end: [0.43, 0, 0, 0.43847, 160.84, 31.71],
  },
  {
    id: "matrix-3",
    start: [0.43, 0, 0, 0.43, 160.84, 31.71],
    end: [0.46, 0, 0, 0.46, 175.47, 45.36],
  },
  {
    id: "matrix-4",
    start: [0.46, 0, 0, 0.46, 175.47, 45.36],
    end: [0.49, 0, 0, 0.49, 180.05, 63.03],
  },
  {
    id: "matrix-5",
    start: [0.49, 0, 0, 0.49, 180.05, 63.03],
    end: [0.52, 0, 0, 0.52, 171.06, 82.28],
  },
  {
    id: "matrix-6",
    start: [0.52, 0, 0, 0.52, 171.06, 82.28],
    end: [0.55, 0, 0, 0.55, 146.15, 98.26],
  },
  {
    id: "matrix-7",
    start: [0.55, 0, 0, 0.55, 146.15, 98.26],
    end: [0.58, 0, 0, 0.58, 108.89, 106.12],
  },
  {
    id: "matrix-8",
    start: [0.58, 0, 0, 0.58, 108.89, 106.12],
    end: [0.56, 0, 0, 0.56, 69.43, 103.17],
  },
  {
    id: "matrix-9",
    start: [0.56, 0, 0, 0.56, 69.43, 103.17],
    end: [0.53, 0, 0, 0.53, 38.31, 90.1],
  },
  {
    id: "matrix-10",
    start: [0.53, 0, 0, 0.53, 38.31, 90.1],
    end: [0.5, 0, 0, 0.5, 21.75, 71.75],
  },
  {
    id: "matrix-11",
    start: [0.5, 0, 0, 0.5, 21.75, 71.75],
    end: [0.47, 0, 0, 0.47, 20.72, 52.95],
  },
  {
    id: "matrix-12",
    start: [0.47, 0, 0, 0.47, 20.72, 52.95],
    end: [0.44, 0, 0, 0.44, 31.56, 37.3],
  },
  {
    id: "matrix-13",
    start: [0.44, 0, 0, 0.44, 31.56, 37.3],
    end: [0.41, 0, 0, 0.41, 49.3, 25.92],
  },
  {
    id: "matrix-14",
    start: [0.41, 0, 0, 0.41, 49.3, 25.92],
    end: [0.39, 0, 0, 0.39, 70.91, 18.71],
  },
  {
    id: "matrix-15",
    start: [0.39, 0, 0, 0.39, 70.91, 18.71],
    end: [0.36, 0, 0, 0.36, 94.91, 16.03],
  },
  {
    id: "matrix-16",
    start: [0.36, 0, 0, 0.36, 94.91, 16.03],
    end: [0.37, 0, 0, 0.37, 118.73, 17.03],
  },
];
